const prefix = 'THEMENFILTERS/'

export const SET_FULLTEXT_THEMEN = prefix + 'SET_FULLTEXT_THEMEN'
export const SET_FULLTEXT_REFERENTEN = prefix + 'SET_FULLTEXT_REFERENTEN'
export const SET_EINSATZGEBIET = prefix + 'SET_EINSATZGEBIET'
export const RESET = prefix + 'RESET'



// WEBPACK FOOTER //
// ./src/types/themenFilters.js